import React, { useState } from "react";

const projectData = [
  {
    title: "Vertriebsprozess-Optimierung",
    subtitle: "Maschinenbau | 250 MA | Bayern",
    duration: "Projektdauer: 10 Wochen",
    bullets: [
      "Analyse & Optimierung der Vertriebsprozesse",
      "Bewertung der CRM-Nutzung",
      "Entwicklung konkreter Verbesserungsvorschläge",
      "Steigerung der Effizienz und verkürzte Vertriebszyklen"
    ],
    image: "/assets/meeting6.jpg"
  },
  {
    title: "Digitalisierungsstrategie Finanzprozesse",
    subtitle: "Lebensmittelindustrie | 400 MA | NRW",
    duration: "Projektdauer: 16 Wochen",
    bullets: [
      "Analyse von Finanz- & Rechnungswesenprozessen",
      "Automatisierungspotenziale identifizieren",
      "Entwicklung digitaler Workflows",
      "Zeitersparnis und Datenqualität verbessert"
    ],
    image: "/assets/meeting7.jpg"
  },
  {
    title: "Markteintrittsstrategie neue Produktlinie",
    subtitle: "Elektrotechnik | 180 MA | Baden-Württemberg",
    duration: "Projektdauer: 4 Wochen",
    bullets: [
      "Markt- und Wettbewerbsanalyse",
      "Zielgruppensegmentierung",
      "Go-to-Market-Plan erstellen",
      "Praxisnahe Vertriebsplanung"
    ],
    image: "/assets/meeting8.jpg"
  },
  {
    title: "F&B Strategie für 5-Sterne-Resort",
    subtitle: "Hotellerie | Saudi-Arabien",
    duration: "Projektdauer: 6 Wochen",
    bullets: [
      "Machbarkeitsstudie für F&B Konzept",
      "Entwicklung innovativer Gastronomieideen",
      "Luxusmarktanalyse",
      "Unterstützung internationaler Hotelkette"
    ],
    image: "/assets/meeting2.jpg"
  }
];


const InfoSectionProjekte = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="project-section" id="projekt-scroll">
      <div className="project-header">
        <h2 className="project-title-main">
          Erfolg ist kein Zufall – sondern das <span className="project-highlight">Ergebnis guter Projektarbeit.</span>
        </h2>
        <p className="project-subline">
          Vier Fallstudien aus verschiedenen Branchen zeigen, wie datenbasierte Strategien nachhaltige Effizienz, Umsatzsteigerung und strukturelle Transformation ermöglichen.
        </p>
      </div>

      <div className="project-nav">
        {projectData.map((proj, idx) => (
          <button
            key={idx}
            className={`project-nav-button ${idx === activeIndex ? "project-nav-active" : ""}`}
            onClick={() => setActiveIndex(idx)}
          >
            {proj.title}
          </button>
        ))}
      </div>

      <div className="project-card-wrapper">
        {projectData.map((proj, index) => (
          <div
            key={index}
            className={`project-card ${
              index === activeIndex
                ? "center"
                : index < activeIndex
                ? "left"
                : "right"
            }`}
          >
            <div className="project-card-image">
              <img src={proj.image} alt="Projektbild" />
            </div>
            <div className="project-card-text">
              <h3 className="project-title">{proj.title}</h3>
              <h4 className="project-subtitle">{proj.subtitle}</h4>
              <ul className="project-bullets">
                {proj.bullets.map((point, idx) => (
                  <li key={idx} className="project-bullet">{point}</li>
                ))}
              </ul>
              <div className="project-duration">{proj.duration}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default InfoSectionProjekte;